import { Component, Input, OnInit } from '@angular/core';
import { numSequence } from '@app/shared/utils/num-sequence';

@Component({
  selector: 'app-skeleton-table',
  templateUrl: './skeleton-table.component.html',
  styleUrls: ['./skeleton-table.component.sass'],
})
export class SkeletonTableComponent {
  @Input() columns = 0;
  @Input() rows = 0;

  numSequence = numSequence;

  constructor() {}
}
